export default __webpack_public_path__ + "static/media/fa-angle-down_White.d0454d6e.png";